$(document).on('click', '.meanmenu-reveal, [data-menu-toggle]', function () {
  if ($('a.meanmenu-reveal').hasClass('meanclose')) {
    $('body').attr('data-nav', 'opened');
  } else {
    $('body').removeAttr('data-nav');
  }
});
